import React, { useState, useEffect } from 'react';

function NoteForm({ onSubmit, editingNote, onCancel }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Update form when editing note changes
  useEffect(() => {
    if (editingNote) {
      setTitle(editingNote.title || '');
      setContent(editingNote.content || '');
    } else {
      setTitle('');
      setContent('');
    }
  }, [editingNote]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert('Please enter a title for your note');
      return;
    }

    if (!content.trim()) {
      alert('Please enter some content for your note');
      return;
    }

    setSubmitting(true);

    const noteData = {
      title: title.trim(),
      content: content.trim(),
    };

    let success;
    if (editingNote) {
      success = await onSubmit(editingNote.id, noteData);
    } else {
      success = await onSubmit(noteData);
    }

    setSubmitting(false);

    if (success) {
      // Clear form only if not editing or if edit was successful
      if (!editingNote) {
        setTitle('');
        setContent('');
      }
    }
  };

  const handleCancel = () => {
    setTitle('');
    setContent('');
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <form className="note-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="note-title">
          Title <span className="required">*</span>
        </label>
        <input
          type="text"
          id="note-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter note title"
          disabled={submitting}
          maxLength={200}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="note-content">
          Content <span className="required">*</span>
        </label>
        <textarea
          id="note-content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Enter note content"
          disabled={submitting}
          rows={6}
          required
        />
      </div>

      <div className="form-actions">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={submitting}
        >
          {submitting ? 'Saving...' : (editingNote ? 'Update Note' : 'Create Note')}
        </button>

        {editingNote && onCancel && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCancel}
            disabled={submitting}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default NoteForm;
